import React, { useState, useRef, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AuthContext from '../../../contexts/auth';
import SidebarContext from '../../../contexts/sidebar';
import { translate } from '../../../utils/Common';
import * as BsIcons from 'react-icons/bs';
import UserMenu from '../../common/UserMenu';
import styles from './MobileTopNavbar.module.css';

const MobileTopNavbar = () => {
    const sidebarContext = useContext(SidebarContext);
    const userContext = useContext(AuthContext);
    const history = useHistory();
    const menuRef = useRef(null);

    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsProfileMenuOpen(false);
            }
        };

        if (isProfileMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isProfileMenuOpen]);

    // Solo mostrar en móviles - después de todos los hooks
    if (!sidebarContext.isMobile) {
        return null;
    }

    const handleProfileClick = () => {
        setIsProfileMenuOpen(!isProfileMenuOpen);
    };

    const handleProfileOption = (path) => {
        history.push(path);
        setIsProfileMenuOpen(false);
    };


    const handleLogout = () => {
        userContext.signOut();
        setIsProfileMenuOpen(false);
        history.push('/login');
    };

    const handleLogoClick = () => {
        history.push('/dashboard/');
    };

    return (
        <>
            <nav className={styles.topNav}>
                <div className={styles.logoContainer} onClick={handleLogoClick}>
                    <div 
                        className={styles.logo}
                        style={{
                            backgroundImage: "url(/img/logo-boxit.png)",
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center'
                        }}
                    />
                </div>

                <div className={styles.actionsContainer}>
                    {/* Perfil */}
                    <div ref={menuRef} className={styles.profileContainer}>
                        <button
                            className={`${styles.actionButton} ${isProfileMenuOpen ? styles.actionButtonActive : ''}`}
                            onClick={handleProfileClick}
                            aria-label={translate('navbar.profile')}
                        >
                            <BsIcons.BsPersonCircle className={styles.actionIcon} size={22} />
                        </button>

                        <UserMenu
                            isOpen={isProfileMenuOpen}
                            onClose={() => setIsProfileMenuOpen(false)}
                            onProfileClick={() => handleProfileOption('/dashboard/profile')}
                            onLogout={handleLogout}
                            variant="mobile"
                        />
                    </div>
                </div>
            </nav>

        </>
    );
};

export default MobileTopNavbar;

